var _style, _g, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _polygon9, _polygon10, _polygon11, _polygon12, _defs, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScheLinge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 230.6 198",
    style: {
      enableBackground: "new 0 0 230.6 198"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A5AEB6;}\n\t.st1{fill:#939EA8;}\n\t.st2{fill:#DADEE1;}\n\t.st3{fill:#00E2FF;}\n\t.st4{fill:#ECEEF0;}\n\t.st5{fill:#C8CED3;}\n\t.st6{fill:url(#SVGID_1_);}\n\t.st7{fill:url(#SVGID_2_);}\n\t.st8{fill:url(#SVGID_3_);}\n\t.st9{fill:url(#SVGID_4_);}\n\t.st10{fill:url(#SVGID_5_);}\n\t.st11{opacity:0.14;}\n\t.st12{opacity:0;fill:#002B50;}\n\t.st13{opacity:0.0323;fill:#002B50;}\n\t.st14{opacity:0.0645;fill:#002B50;}\n\t.st15{opacity:0.0968;fill:#002B50;}\n\t.st16{opacity:0.129;fill:#002B50;}\n\t.st17{opacity:0.1613;fill:#002B50;}\n\t.st18{opacity:0.1935;fill:#002B50;}\n\t.st19{opacity:0.2258;fill:#002B50;}\n\t.st20{opacity:0.2581;fill:#002B50;}\n\t.st21{opacity:0.2903;fill:#002B50;}\n\t.st22{opacity:0.3226;fill:#002B50;}\n\t.st23{opacity:0.3548;fill:#002B50;}\n\t.st24{opacity:0.3871;fill:#002B50;}\n\t.st25{opacity:0.4194;fill:#002B50;}\n\t.st26{opacity:0.4516;fill:#002B50;}\n\t.st27{opacity:0.4839;fill:#002B50;}\n\t.st28{opacity:0.5161;fill:#002B50;}\n\t.st29{opacity:0.5484;fill:#002B50;}\n\t.st30{opacity:0.5806;fill:#002B50;}\n\t.st31{opacity:0.6129;fill:#002B50;}\n\t.st32{opacity:0.6452;fill:#002B50;}\n\t.st33{opacity:0.6774;fill:#002B50;}\n\t.st34{opacity:0.7097;fill:#002B50;}\n\t.st35{opacity:0.7419;fill:#002B50;}\n\t.st36{opacity:0.7742;fill:#002B50;}\n\t.st37{opacity:0.8065;fill:#002B50;}\n\t.st38{opacity:0.8387;fill:#002B50;}\n\t.st39{opacity:0.871;fill:#002B50;}\n\t.st40{opacity:0.9032;fill:#002B50;}\n\t.st41{opacity:0.9355;fill:#002B50;}\n\t.st42{opacity:0.9677;fill:#002B50;}\n\t.st43{fill:#002B50;}\n\t.st44{fill:url(#SVGID_6_);}\n\t.st45{fill:url(#SVGID_7_);}\n\t.st46{fill:url(#SVGID_8_);}\n\t.st47{fill:url(#SVGID_9_);}\n\t.st48{fill-rule:evenodd;clip-rule:evenodd;fill:#EEEEEE;}\n\t.st49{fill-rule:evenodd;clip-rule:evenodd;fill:#ECEEF0;}\n\t.st50{fill-rule:evenodd;clip-rule:evenodd;fill:#C8CED3;}\n\t.st51{fill-rule:evenodd;clip-rule:evenodd;fill:#939EA8;}\n\t.st52{clip-path:url(#SVGID_11_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REPERES"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.43,59.38l-0.27-6.36l0.06,20.71l-65.73,37.95l-0.06-20.71l-0.27,6.67l0.26,84.7h0.27l-0.02-2.01 l65.73-37.95l0.02,2.01h0.27L180.43,59.38z M114.67,179.71l-0.17-67.42l65.73-37.95l0.17,67.42L114.67,179.71z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "115.98,181.38 114.39,180.46 180.66,142.2 182.24,143.12  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "182.24,143.12 182.26,145.14 116,183.39 115.99,181.5 115.98,181.38  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "182.06,75.09 115.8,113.34 115.82,145.25 115.97,180.77 182.24,142.51  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "115.8,113.34 114.22,112.43 180.48,74.17 182.06,75.09  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "182,53.77 115.74,92.03 115.8,112.74 182.06,74.48  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "154.91,77.04 154.93,86.18 142.91,93.12 142.88,83.98  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "182,53.77 180.42,52.85 180.42,52.85 114.6,14.61 114.33,14.76 48.6,52.71 48.34,52.86 114.17,91.12  114.17,91.11 115.74,92.03  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "116,183.39 115.98,181.38 114.4,180.46 114.4,179.85 115.97,180.77 115.8,113.34 114.23,112.43  114.22,111.82 115.8,112.74 115.74,92.03 114.16,91.11 114.16,91.11 48.34,52.86 48.6,144.23 114.43,182.49 114.43,182.48  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M165.06,95.86c3.46,2.47,5.58,7.11,5.59,13.52c0.02,6.41-2.06,13.47-5.5,19.92 c-1.28-0.91-2.38-2.13-3.25-3.62c-1.49-2.53-2.33-5.86-2.35-9.9c-0.01-4.04,0.82-8.34,2.28-12.57 C162.7,100.72,163.78,98.25,165.06,95.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.2568,
    y1: 77.9234,
    x2: 158.7517,
    y2: 75.3342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEC0C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FCFCFC"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M157.36,77.98l0.53,0.31c-0.19-0.11-0.31-0.35-0.31-0.68c0-0.08,0.01-0.16,0.02-0.24 c0-0.01,0-0.03,0.01-0.04c0.01-0.08,0.03-0.15,0.05-0.23c0-0.01,0-0.01,0.01-0.02c0.03-0.08,0.06-0.17,0.09-0.25c0,0,0,0,0,0 c0.04-0.08,0.08-0.17,0.12-0.25c0,0,0-0.01,0.01-0.01c0.05-0.08,0.1-0.15,0.15-0.23c0-0.01,0.01-0.01,0.01-0.02 c0.05-0.07,0.1-0.13,0.16-0.19c0.01-0.01,0.02-0.02,0.04-0.04c0.02-0.02,0.05-0.05,0.07-0.07c0.1-0.1,0.21-0.18,0.32-0.25 c0.07-0.04,0.13-0.07,0.2-0.09c0.01,0,0.02-0.01,0.03-0.01c0.06-0.02,0.12-0.03,0.18-0.04c0.01,0,0.01,0,0.02,0 c0.06-0.01,0.12,0,0.17,0.01c0,0,0.01,0,0.01,0c0.05,0.01,0.11,0.03,0.15,0.06l-0.34-0.2l-0.19-0.11 c-0.02-0.01-0.04-0.02-0.05-0.03c-0.02-0.01-0.04-0.01-0.06-0.02c-0.01,0-0.03-0.01-0.04-0.01c0,0-0.01,0-0.01,0 c0,0-0.01,0-0.01,0c-0.02,0-0.04-0.01-0.06-0.01c-0.02,0-0.05,0-0.07,0c-0.01,0-0.02,0-0.02,0c0,0-0.01,0-0.01,0 c-0.01,0-0.03,0-0.04,0c-0.03,0-0.06,0.01-0.09,0.02c-0.01,0-0.03,0.01-0.04,0.01c-0.01,0-0.03,0.01-0.04,0.01 c-0.02,0.01-0.03,0.01-0.05,0.02c-0.05,0.02-0.1,0.05-0.15,0.07c-0.11,0.06-0.22,0.15-0.32,0.24c-0.01,0.01-0.02,0.02-0.04,0.03 c-0.01,0.01-0.03,0.03-0.04,0.05c-0.01,0.01-0.02,0.02-0.03,0.04c-0.01,0.01-0.03,0.03-0.04,0.04c-0.03,0.03-0.06,0.07-0.09,0.11 c-0.01,0.01-0.02,0.02-0.03,0.04c-0.01,0.01-0.01,0.02-0.02,0.03c-0.01,0.01-0.02,0.02-0.02,0.03c-0.02,0.03-0.04,0.06-0.06,0.09 c-0.02,0.03-0.04,0.06-0.06,0.09c0,0,0,0.01-0.01,0.01c0,0,0,0,0,0c-0.01,0.02-0.03,0.05-0.04,0.08 c-0.02,0.03-0.03,0.06-0.05,0.09c-0.01,0.03-0.03,0.06-0.04,0.09c-0.01,0.03-0.03,0.06-0.04,0.1c-0.01,0.03-0.03,0.07-0.04,0.1 c-0.01,0.02-0.01,0.03-0.01,0.05c0,0.01-0.01,0.02-0.01,0.02c0,0.01-0.01,0.02-0.01,0.04c-0.01,0.04-0.02,0.08-0.03,0.12 c-0.01,0.02-0.01,0.05-0.01,0.07c0,0.01,0,0.03-0.01,0.04c0,0.01-0.01,0.02-0.01,0.04c-0.01,0.07-0.01,0.14-0.01,0.21 C157.05,77.64,157.17,77.87,157.36,77.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.703,
    y1: 88.6346,
    x2: 140.1981,
    y2: 86.0451
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEC0C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FCFCFC"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M138.81,88.69l0.53,0.31c-0.19-0.11-0.31-0.34-0.31-0.68c0-0.08,0.01-0.16,0.02-0.24 c0-0.02,0.01-0.03,0.01-0.05c0.01-0.07,0.03-0.15,0.05-0.22c0-0.01,0.01-0.02,0.01-0.03c0.02-0.08,0.05-0.16,0.09-0.24 c0-0.01,0.01-0.02,0.01-0.02c0.04-0.08,0.08-0.16,0.12-0.24c0,0,0,0,0-0.01c0.05-0.08,0.1-0.15,0.15-0.23 c0-0.01,0.01-0.01,0.01-0.02c0.05-0.07,0.1-0.13,0.16-0.19c0.01-0.01,0.02-0.02,0.03-0.03c0.02-0.03,0.05-0.05,0.08-0.07 c0.1-0.1,0.21-0.18,0.32-0.25c0.07-0.04,0.13-0.07,0.2-0.09c0.01,0,0.02-0.01,0.03-0.01c0.06-0.02,0.12-0.03,0.18-0.04 c0.01,0,0.01,0,0.01,0c0.06-0.01,0.12,0,0.17,0.01c0,0,0.01,0,0.01,0c0.05,0.01,0.1,0.03,0.15,0.06l-0.17-0.1l-0.36-0.21 c-0.02-0.01-0.04-0.02-0.05-0.03c-0.02-0.01-0.04-0.01-0.06-0.02c-0.01,0-0.03-0.01-0.04-0.01l0,0c-0.01,0-0.01,0-0.02,0 c-0.02,0-0.04-0.01-0.07-0.01c-0.02,0-0.05,0-0.07,0c-0.01,0-0.01,0-0.02,0c-0.01,0-0.01,0-0.01,0c-0.01,0-0.03,0-0.04,0 c-0.03,0-0.06,0.01-0.09,0.02c-0.01,0-0.02,0.01-0.04,0.01c-0.01,0-0.03,0.01-0.04,0.01c-0.02,0.01-0.03,0.01-0.05,0.02 c-0.05,0.02-0.1,0.04-0.15,0.07c-0.11,0.07-0.22,0.15-0.32,0.25c-0.01,0.01-0.02,0.01-0.03,0.02c-0.01,0.01-0.02,0.03-0.04,0.04 c-0.01,0.01-0.03,0.03-0.04,0.04c-0.01,0.01-0.03,0.03-0.04,0.04c-0.03,0.04-0.06,0.07-0.09,0.11c-0.01,0.01-0.02,0.02-0.02,0.03 c-0.01,0.01-0.01,0.02-0.02,0.03c-0.01,0.01-0.02,0.02-0.03,0.04c-0.02,0.03-0.04,0.06-0.06,0.09c-0.02,0.03-0.04,0.06-0.05,0.09 c0,0,0,0,0,0c0,0.01-0.01,0.01-0.01,0.02c-0.01,0.02-0.03,0.05-0.04,0.07c-0.02,0.03-0.03,0.06-0.05,0.09 c-0.01,0.02-0.02,0.05-0.03,0.07c0,0,0,0.01-0.01,0.01c0,0,0,0,0,0.01c-0.01,0.03-0.03,0.06-0.04,0.09 c-0.01,0.03-0.02,0.07-0.04,0.1c-0.01,0.01-0.01,0.03-0.01,0.05c0,0.01,0,0.02-0.01,0.02c0,0.01-0.01,0.03-0.01,0.04 c-0.01,0.04-0.02,0.08-0.03,0.12c-0.01,0.02-0.01,0.05-0.01,0.07c0,0.01,0,0.03-0.01,0.04s-0.01,0.02-0.01,0.04 c-0.01,0.07-0.01,0.14-0.01,0.2C138.5,88.35,138.62,88.58,138.81,88.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.2747,
    y1: 84.0128,
    x2: 158.7693,
    y2: 81.424
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEC0C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FCFCFC"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M159.06,81.73C159.07,81.73,159.07,81.73,159.06,81.73c0.07-0.01,0.13,0,0.19,0.01c0,0,0,0,0.01,0 c0.06,0.01,0.11,0.03,0.16,0.06l-0.53-0.31c0,0,0,0-0.01,0c-0.02-0.01-0.04-0.02-0.05-0.03c-0.02-0.01-0.04-0.01-0.06-0.02 c-0.01,0-0.02-0.01-0.04-0.01c0,0-0.01,0-0.01,0c0,0-0.01,0-0.01,0c-0.02,0-0.04-0.01-0.06-0.01c-0.02,0-0.05,0-0.07,0 c-0.01,0-0.01,0-0.02,0c0,0-0.01,0-0.02,0c-0.01,0-0.03,0-0.04,0c-0.03,0-0.06,0.01-0.09,0.02c-0.01,0-0.03,0.01-0.04,0.02 c-0.01,0-0.02,0.01-0.03,0.01c-0.02,0.01-0.03,0.01-0.05,0.02c-0.05,0.02-0.1,0.05-0.15,0.07c-0.11,0.06-0.21,0.15-0.31,0.24 c-0.01,0.01-0.03,0.02-0.04,0.03c-0.02,0.01-0.03,0.03-0.05,0.05c-0.01,0.01-0.02,0.02-0.03,0.03c-0.01,0.01-0.03,0.03-0.04,0.04 c-0.03,0.04-0.06,0.07-0.09,0.11c-0.01,0.01-0.02,0.03-0.03,0.04c0,0.01-0.01,0.01-0.01,0.02c-0.01,0.01-0.02,0.02-0.03,0.04 c-0.02,0.03-0.04,0.06-0.06,0.09c-0.02,0.03-0.04,0.06-0.06,0.09c0,0,0,0,0,0.01c0,0,0,0.01-0.01,0.01 c-0.01,0.02-0.03,0.05-0.04,0.07c-0.02,0.03-0.03,0.06-0.05,0.09c-0.01,0.03-0.03,0.06-0.04,0.08c0,0,0,0,0,0c0,0,0,0,0,0.01 c-0.01,0.03-0.03,0.06-0.04,0.1c-0.01,0.03-0.02,0.07-0.04,0.1c-0.01,0.02-0.01,0.03-0.01,0.05c0,0.01,0,0.02-0.01,0.02 c0,0.01-0.01,0.02-0.01,0.04c-0.01,0.04-0.02,0.08-0.03,0.12c0,0.02-0.01,0.05-0.01,0.07c0,0.01-0.01,0.03-0.01,0.04 c0,0.01,0,0.02-0.01,0.03c-0.01,0.07-0.01,0.14-0.01,0.21c0,0.33,0.12,0.57,0.31,0.68l0.53,0.31c-0.19-0.11-0.31-0.34-0.31-0.68 c0-0.08,0.01-0.16,0.02-0.25c0-0.01,0-0.02,0.01-0.03c0.01-0.08,0.03-0.16,0.05-0.23c0-0.01,0-0.02,0.01-0.02 c0.03-0.08,0.06-0.17,0.09-0.25c0,0,0-0.01,0-0.01c0.04-0.08,0.08-0.17,0.12-0.25c0,0,0,0,0-0.01c0.05-0.08,0.1-0.16,0.15-0.23 c0,0,0.01-0.01,0.01-0.01c0.05-0.07,0.1-0.13,0.16-0.19c0.01-0.01,0.02-0.02,0.03-0.03c0.02-0.03,0.05-0.05,0.08-0.07 c0.1-0.1,0.21-0.18,0.32-0.25c0.07-0.04,0.13-0.07,0.2-0.09c0.01,0,0.02-0.01,0.03-0.01C158.94,81.75,159,81.73,159.06,81.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.7208,
    y1: 94.7234,
    x2: 140.215,
    y2: 92.1353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEC0C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FCFCFC"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M140.5,92.44c0.01,0,0.01,0,0.02,0c0.06,0,0.11,0,0.17,0.01c0,0,0.01,0,0.01,0 c0.05,0.01,0.11,0.03,0.15,0.06l-0.35-0.2l-0.18-0.11c-0.02-0.01-0.04-0.02-0.05-0.03c-0.02-0.01-0.04-0.01-0.06-0.02 c-0.01,0-0.03-0.01-0.04-0.01c0,0-0.01,0-0.01,0c-0.01,0-0.01,0-0.01,0c-0.02,0-0.04-0.01-0.06-0.01c-0.02,0-0.05,0-0.07,0 c-0.01,0-0.02,0-0.02,0c0,0-0.01,0-0.01,0c-0.01,0-0.03,0-0.04,0c-0.03,0-0.06,0.01-0.09,0.02c-0.01,0-0.03,0.01-0.04,0.01 c-0.01,0-0.02,0.01-0.04,0.01c-0.02,0.01-0.03,0.01-0.05,0.02c-0.05,0.02-0.1,0.04-0.15,0.07c-0.11,0.06-0.22,0.15-0.32,0.25 c-0.01,0.01-0.02,0.02-0.03,0.03c-0.02,0.01-0.03,0.03-0.04,0.05c-0.01,0.01-0.02,0.02-0.03,0.03c-0.01,0.02-0.03,0.03-0.04,0.05 c-0.03,0.04-0.06,0.07-0.09,0.11c-0.01,0.01-0.02,0.03-0.03,0.04c0,0.01-0.01,0.01-0.01,0.02c-0.01,0.01-0.02,0.02-0.03,0.04 c-0.02,0.03-0.04,0.06-0.06,0.09c-0.02,0.03-0.04,0.06-0.06,0.09c0,0,0,0,0,0.01c0,0,0,0,0,0.01c-0.01,0.03-0.03,0.05-0.04,0.08 c-0.02,0.03-0.03,0.06-0.05,0.09c-0.01,0.02-0.02,0.05-0.03,0.07c0,0.01-0.01,0.01-0.01,0.02l0,0c-0.01,0.03-0.03,0.06-0.04,0.1 c-0.01,0.03-0.02,0.07-0.04,0.1c0,0.01-0.01,0.03-0.01,0.04c0,0.01-0.01,0.02-0.01,0.03c0,0.01-0.01,0.02-0.01,0.03 c-0.01,0.04-0.02,0.08-0.03,0.12c0,0.02-0.01,0.05-0.01,0.07c0,0.02-0.01,0.03-0.01,0.04c0,0.01,0,0.02-0.01,0.03 c-0.01,0.07-0.01,0.14-0.01,0.2c0,0.33,0.12,0.57,0.31,0.68l0.53,0.31c-0.19-0.11-0.31-0.34-0.31-0.68 c0-0.08,0.01-0.16,0.02-0.24c0-0.01,0-0.02,0.01-0.03c0.01-0.08,0.03-0.15,0.05-0.23c0-0.01,0-0.01,0.01-0.02 c0.05-0.17,0.13-0.35,0.22-0.51c0,0,0,0,0,0c0.09-0.16,0.2-0.3,0.32-0.43c0.01-0.01,0.02-0.02,0.03-0.04 c0.02-0.02,0.05-0.05,0.07-0.07c0.1-0.1,0.21-0.18,0.32-0.25c0.07-0.04,0.13-0.07,0.2-0.09c0.01,0,0.02-0.01,0.03-0.01 C140.39,92.46,140.45,92.45,140.5,92.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.8737,
    y1: 75.6928,
    x2: 172.4816,
    y2: 65.9797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEC0C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FCFCFC"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M167.99,73.35c0.05-0.29,0.12-0.58,0.2-0.87c0.01-0.03,0.02-0.05,0.02-0.08c0.1-0.32,0.21-0.63,0.35-0.94 c0,0,0-0.01,0-0.01c0.14-0.32,0.3-0.63,0.47-0.94c0-0.01,0.01-0.02,0.01-0.02c0.17-0.29,0.36-0.58,0.56-0.85 c0.02-0.02,0.04-0.05,0.05-0.07c0.18-0.25,0.38-0.48,0.59-0.7c0.04-0.05,0.08-0.09,0.13-0.13c0.17-0.17,0.34-0.33,0.52-0.48 c0.07-0.06,0.14-0.13,0.22-0.19c0.24-0.19,0.49-0.37,0.75-0.52c0.17-0.1,0.33-0.18,0.49-0.25c0.06-0.02,0.11-0.05,0.17-0.07 c0.09-0.04,0.19-0.07,0.28-0.09c0.06-0.02,0.11-0.03,0.17-0.05c0.06-0.01,0.11-0.02,0.17-0.04c0.07-0.01,0.14-0.02,0.21-0.03 c0.04,0,0.08-0.01,0.11-0.01c0.09-0.01,0.18-0.01,0.26-0.01c0.02,0,0.03,0,0.05,0c0.1,0.01,0.2,0.02,0.29,0.04 c0.02,0.01,0.05,0.01,0.07,0.02c0.07,0.02,0.15,0.04,0.22,0.06c0.02,0.01,0.05,0.02,0.07,0.03c0.09,0.04,0.18,0.07,0.26,0.12 l-1.58-0.92c-0.01,0-0.01-0.01-0.02-0.01c-0.06-0.04-0.13-0.07-0.2-0.1c-0.01-0.01-0.02-0.01-0.03-0.01 c-0.03-0.01-0.05-0.02-0.08-0.03c-0.03-0.01-0.06-0.02-0.1-0.03c-0.03-0.01-0.07-0.02-0.1-0.02c-0.03-0.01-0.06-0.01-0.09-0.02 c-0.01,0-0.02-0.01-0.03-0.01c-0.08-0.01-0.16-0.02-0.24-0.03c0,0-0.01,0-0.01,0c-0.02,0-0.04,0-0.07,0c-0.06,0-0.12,0-0.18,0 c-0.02,0-0.04,0-0.06,0.01c-0.04,0-0.08,0.01-0.13,0.01c-0.04,0-0.07,0.01-0.11,0.01c-0.03,0.01-0.06,0.01-0.09,0.02 c-0.06,0.01-0.11,0.02-0.17,0.04c-0.03,0.01-0.06,0.01-0.09,0.02c-0.03,0.01-0.06,0.02-0.09,0.03c-0.09,0.03-0.19,0.06-0.28,0.1 c-0.03,0.01-0.06,0.02-0.1,0.03c-0.02,0.01-0.04,0.02-0.06,0.03c-0.16,0.07-0.33,0.15-0.5,0.25c-0.26,0.15-0.5,0.33-0.75,0.52 c-0.08,0.06-0.15,0.13-0.23,0.2c-0.12,0.1-0.24,0.2-0.35,0.31c-0.05,0.05-0.1,0.11-0.15,0.16c-0.04,0.05-0.09,0.09-0.13,0.14 c-0.05,0.06-0.1,0.11-0.15,0.16c-0.11,0.13-0.22,0.26-0.32,0.39c-0.03,0.04-0.07,0.09-0.1,0.14c-0.02,0.03-0.04,0.05-0.06,0.08 c-0.03,0.05-0.07,0.09-0.1,0.14c-0.08,0.11-0.16,0.23-0.23,0.34c-0.07,0.11-0.14,0.22-0.21,0.34c-0.01,0.01-0.01,0.02-0.02,0.03 c0,0,0,0.01-0.01,0.01c-0.06,0.1-0.11,0.19-0.16,0.29c-0.06,0.11-0.12,0.22-0.17,0.34c-0.05,0.1-0.1,0.2-0.14,0.31 c0,0.01-0.01,0.01-0.01,0.02c0,0.01-0.01,0.01-0.01,0.02c-0.05,0.12-0.1,0.24-0.15,0.36c-0.05,0.12-0.09,0.25-0.13,0.38 c-0.02,0.06-0.04,0.12-0.06,0.18c-0.01,0.03-0.02,0.06-0.03,0.08c-0.01,0.05-0.03,0.09-0.04,0.14c-0.04,0.15-0.08,0.3-0.11,0.46 c-0.02,0.09-0.03,0.19-0.05,0.28c-0.01,0.04-0.02,0.09-0.02,0.13c-0.01,0.05-0.02,0.09-0.02,0.14c-0.03,0.26-0.05,0.52-0.05,0.77 c0,1.26,0.45,2.14,1.16,2.55l1.58,0.92c-0.71-0.41-1.16-1.3-1.16-2.55c0-0.3,0.03-0.6,0.07-0.91 C167.97,73.44,167.98,73.39,167.99,73.35z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M157.73,71.26c0.61-0.35,1.11-0.07,1.11,0.62c0,0.7-0.49,1.55-1.1,1.9c-0.6,0.35-1.1,0.07-1.1-0.63 C156.64,72.47,157.13,71.61,157.73,71.26z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M140.09,86.49c0.58-0.34,1.06-0.06,1.06,0.6c0,0.67-0.47,1.49-1.06,1.83c-0.59,0.34-1.07,0.07-1.07-0.6 C139.02,87.65,139.5,86.83,140.09,86.49z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M157.75,77.58c0.61-0.35,1.11-0.07,1.11,0.63c0,0.7-0.49,1.55-1.1,1.9c-0.6,0.35-1.1,0.07-1.1-0.63 C156.65,78.79,157.15,77.93,157.75,77.58z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M140.1,92.58c0.58-0.34,1.06-0.06,1.06,0.61c0,0.67-0.47,1.49-1.06,1.83c-0.59,0.34-1.07,0.07-1.07-0.6 C139.04,93.74,139.52,92.92,140.1,92.58z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M171.46,62.7c2.28-1.32,4.13-0.26,4.14,2.36c0.01,2.62-1.83,5.81-4.11,7.13c-2.28,1.32-4.14,0.26-4.14-2.36 C167.33,67.21,169.18,64.02,171.46,62.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M163.15,101.65c-3.98-2.83-9.79-2.72-16.26,1.02c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.77,19.08,21.72,12.18c6.47-3.73,12.27-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C168.59,108.59,166.52,104.06,163.15,101.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M163.22,101.59c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.77,19.08,21.72,12.18c6.47-3.73,12.27-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C168.66,108.53,166.6,103.99,163.22,101.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M163.29,101.53c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.77,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C168.73,108.46,166.67,103.93,163.29,101.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M163.37,101.47c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.77,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C168.81,108.4,166.74,103.87,163.37,101.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M163.44,101.4c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C168.88,108.34,166.82,103.81,163.44,101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M163.51,101.34c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C168.95,108.28,166.89,103.75,163.51,101.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M163.59,101.28c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.03,108.22,166.96,103.68,163.59,101.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M163.66,101.22c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.1,108.15,167.04,103.62,163.66,101.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M163.73,101.15c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.18,108.09,167.11,103.56,163.73,101.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M163.81,101.09c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.25,108.03,167.18,103.5,163.81,101.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M163.88,101.03c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.32,107.97,167.26,103.44,163.88,101.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M163.96,100.97c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.4,107.91,167.33,103.37,163.96,100.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M164.03,100.91c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.47,107.84,167.4,103.31,164.03,100.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M164.1,100.84c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.54,107.78,167.48,103.25,164.1,100.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M164.18,100.78c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.62,107.72,167.55,103.19,164.18,100.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M164.25,100.72c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.69,107.66,167.63,103.13,164.25,100.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M164.32,100.66c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.76,107.59,167.7,103.06,164.32,100.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M164.4,100.6c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.84,107.53,167.77,103,164.4,100.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M164.47,100.53c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.91,107.47,167.85,102.94,164.47,100.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M164.54,100.47c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C169.98,107.41,167.92,102.88,164.54,100.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M164.62,100.41c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C170.06,107.35,167.99,102.81,164.62,100.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M164.69,100.35c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C170.13,107.28,168.07,102.75,164.69,100.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M164.76,100.28c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C170.21,107.22,168.14,102.69,164.76,100.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M164.84,100.22c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C170.28,107.16,168.21,102.63,164.84,100.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M164.91,100.16c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C170.35,107.1,168.29,102.57,164.91,100.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M164.98,100.1c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C170.43,107.03,168.36,102.5,164.98,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M165.06,100.04c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C170.5,106.97,168.43,102.44,165.06,100.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M165.13,99.97c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C170.57,106.91,168.51,102.38,165.13,99.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M165.2,99.91c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C170.65,106.85,168.58,102.32,165.2,99.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M165.28,99.85c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C170.72,106.79,168.65,102.26,165.28,99.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M165.35,99.79c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C170.79,106.72,168.73,102.19,165.35,99.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M165.43,99.73c-3.98-2.83-9.79-2.72-16.26,1.01c-11.95,6.9-21.62,23.55-21.58,37.17 c0.04,13.63,9.76,19.08,21.72,12.18c6.47-3.73,12.26-10.32,16.22-17.74c3.35-6.29,5.38-13.18,5.37-19.44 C170.87,106.66,168.8,102.13,165.43,99.73z"
  }))), /*#__PURE__*/React.createElement("g", null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M165.58,99.49c3.33,2.37,5.37,6.85,5.39,13.02c0.02,6.18-1.99,12.98-5.3,19.2 c-3.9,7.32-9.62,13.83-16.01,17.51c-11.8,6.81-21.4,1.43-21.44-12.03c-0.04-13.45,9.5-29.89,21.3-36.7 C155.91,96.8,161.65,96.69,165.58,99.49z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M178.47,126.75c1.08,0.77,1.75,2.23,1.75,4.24c0.01,2.01-0.65,4.23-1.72,6.25c-1.27,2.38-3.13,4.5-5.21,5.7 c-3.84,2.22-6.97,0.47-6.98-3.92c-0.01-4.38,3.09-9.73,6.94-11.95C175.33,125.88,177.19,125.84,178.47,126.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.4869,
    y1: 108.8355,
    x2: 123.8024,
    y2: 135.7888
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEC0C2"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M128.3,134.98c0.04-0.6,0.1-1.21,0.18-1.82c0.02-0.16,0.05-0.32,0.07-0.48c0.04-0.29,0.08-0.58,0.13-0.87 c0.03-0.19,0.07-0.39,0.1-0.58c0.05-0.27,0.1-0.54,0.16-0.81c0.03-0.15,0.07-0.31,0.1-0.46c0.15-0.7,0.32-1.4,0.52-2.11 c0.03-0.12,0.07-0.24,0.1-0.36c0.16-0.57,0.33-1.14,0.52-1.71c0.03-0.09,0.06-0.19,0.09-0.28c0.19-0.58,0.4-1.16,0.62-1.74 c0.06-0.15,0.11-0.29,0.17-0.44c0.18-0.46,0.37-0.92,0.56-1.38c0.05-0.12,0.1-0.24,0.15-0.36c0.24-0.54,0.48-1.08,0.74-1.61 c0.06-0.13,0.13-0.26,0.2-0.4c0.21-0.42,0.42-0.84,0.64-1.26c0.08-0.15,0.16-0.3,0.24-0.45c0.28-0.53,0.57-1.05,0.87-1.57 c0.04-0.07,0.09-0.14,0.13-0.22c0.28-0.48,0.58-0.96,0.88-1.43c0.08-0.12,0.16-0.25,0.23-0.37c0.36-0.55,0.72-1.1,1.1-1.64 c0.04-0.06,0.08-0.11,0.12-0.16c0.39-0.55,0.78-1.08,1.19-1.61c0.07-0.09,0.14-0.19,0.22-0.28c0.5-0.64,1.01-1.27,1.54-1.88 c0.08-0.1,0.17-0.19,0.25-0.29c0.29-0.33,0.58-0.65,0.87-0.96c0.07-0.07,0.13-0.14,0.19-0.21c0.36-0.38,0.72-0.75,1.09-1.12 c0.07-0.07,0.15-0.14,0.22-0.22c0.47-0.46,0.95-0.91,1.44-1.34c0.06-0.05,0.12-0.11,0.18-0.16c0.51-0.45,1.03-0.87,1.55-1.29 c0.1-0.08,0.21-0.16,0.31-0.24c0.52-0.4,1.05-0.78,1.58-1.15c0.09-0.06,0.19-0.13,0.28-0.19c0.56-0.37,1.12-0.73,1.7-1.06 c0.47-0.27,0.93-0.51,1.38-0.74c0.12-0.06,0.25-0.12,0.37-0.18c0.36-0.18,0.73-0.34,1.09-0.49c0.1-0.04,0.21-0.09,0.31-0.13 c0.35-0.14,0.7-0.28,1.04-0.4c0.05-0.02,0.1-0.04,0.14-0.05c0.39-0.13,0.77-0.25,1.15-0.35c0.22-0.06,0.45-0.12,0.67-0.17 c0.1-0.02,0.21-0.05,0.31-0.08c0.25-0.05,0.5-0.1,0.74-0.14c0.08-0.01,0.16-0.03,0.24-0.04c0.3-0.05,0.6-0.08,0.9-0.11 c0.09-0.01,0.18-0.01,0.27-0.02c0.19-0.01,0.37-0.02,0.55-0.03c0.42-0.01,0.83-0.01,1.24,0.01c0.07,0,0.14,0.01,0.21,0.02 c0.32,0.02,0.64,0.06,0.95,0.11c0.1,0.02,0.21,0.03,0.31,0.05c0.36,0.07,0.72,0.15,1.06,0.25c0.02,0.01,0.03,0.01,0.05,0.02 c0.33,0.1,0.65,0.21,0.96,0.34c0.09,0.04,0.18,0.08,0.27,0.11c0.27,0.12,0.53,0.24,0.78,0.38c0.09,0.05,0.18,0.09,0.26,0.14 l-0.53-0.31c-0.04-0.02-0.08-0.04-0.12-0.07c-0.04-0.03-0.09-0.04-0.14-0.07c-0.26-0.14-0.52-0.27-0.79-0.39 c-0.05-0.02-0.09-0.05-0.14-0.07c-0.04-0.02-0.08-0.03-0.12-0.04c-0.31-0.12-0.62-0.24-0.95-0.33c-0.02-0.01-0.04-0.01-0.06-0.02 c0,0-0.01,0-0.01,0c-0.35-0.1-0.7-0.18-1.06-0.25c-0.04-0.01-0.08-0.02-0.12-0.03c-0.06-0.01-0.12-0.01-0.18-0.02 c-0.31-0.05-0.63-0.09-0.95-0.11c-0.06,0-0.11-0.02-0.16-0.02c-0.02,0-0.04,0-0.06,0c-0.4-0.02-0.82-0.02-1.24-0.01 c-0.04,0-0.08,0-0.11,0c-0.15,0.01-0.29,0.02-0.44,0.03c-0.09,0.01-0.17,0.01-0.26,0.02c-0.3,0.03-0.59,0.06-0.9,0.11 c0,0-0.01,0-0.01,0c-0.04,0.01-0.08,0.02-0.13,0.02c-0.28,0.05-0.56,0.1-0.84,0.16c-0.11,0.02-0.22,0.05-0.33,0.08 c-0.19,0.04-0.38,0.09-0.57,0.14c-0.03,0.01-0.05,0.02-0.08,0.02c-0.38,0.1-0.76,0.22-1.15,0.35c-0.06,0.02-0.12,0.05-0.18,0.07 c-0.33,0.12-0.66,0.24-0.99,0.38c-0.04,0.02-0.08,0.03-0.11,0.04c-0.08,0.03-0.16,0.07-0.24,0.11c-0.35,0.15-0.7,0.31-1.05,0.48 c-0.13,0.06-0.26,0.12-0.39,0.19c-0.46,0.23-0.92,0.47-1.38,0.74c-0.57,0.33-1.14,0.69-1.7,1.06c-0.09,0.06-0.19,0.12-0.28,0.19 c-0.53,0.36-1.06,0.75-1.58,1.14c-0.11,0.08-0.21,0.16-0.31,0.24c-0.52,0.41-1.04,0.84-1.55,1.28c-0.06,0.05-0.12,0.11-0.18,0.16 c-0.49,0.43-0.97,0.89-1.45,1.35c-0.05,0.04-0.09,0.08-0.14,0.13c-0.02,0.02-0.05,0.05-0.07,0.08c-0.37,0.36-0.73,0.74-1.09,1.12 c-0.06,0.07-0.12,0.14-0.19,0.21c-0.3,0.32-0.59,0.65-0.88,0.98c-0.04,0.04-0.08,0.09-0.12,0.13c-0.04,0.05-0.08,0.1-0.12,0.15 c-0.53,0.61-1.04,1.23-1.54,1.88c-0.02,0.03-0.05,0.06-0.07,0.09c-0.05,0.07-0.1,0.14-0.15,0.21c-0.41,0.53-0.8,1.07-1.19,1.61 c-0.03,0.04-0.05,0.07-0.08,0.11c-0.01,0.01-0.02,0.03-0.03,0.04c-0.38,0.54-0.74,1.08-1.1,1.64c-0.04,0.06-0.08,0.11-0.12,0.17 c-0.04,0.07-0.08,0.14-0.13,0.21c-0.31,0.49-0.62,0.99-0.91,1.5c-0.02,0.03-0.04,0.07-0.06,0.1c-0.01,0.01-0.01,0.02-0.02,0.03 c-0.31,0.53-0.61,1.07-0.9,1.62c-0.03,0.05-0.06,0.1-0.08,0.15c-0.04,0.08-0.08,0.16-0.12,0.24c-0.23,0.43-0.45,0.87-0.67,1.31 c-0.04,0.09-0.09,0.17-0.13,0.26c-0.02,0.04-0.04,0.08-0.06,0.12c-0.26,0.54-0.51,1.09-0.75,1.64c-0.01,0.03-0.02,0.05-0.04,0.08 c-0.03,0.07-0.06,0.14-0.09,0.21c-0.2,0.48-0.4,0.96-0.59,1.44c-0.03,0.08-0.07,0.17-0.1,0.25c-0.02,0.06-0.04,0.12-0.06,0.18 c-0.22,0.59-0.43,1.17-0.63,1.76c-0.01,0.02-0.02,0.04-0.02,0.06c-0.02,0.05-0.03,0.1-0.05,0.15c-0.2,0.59-0.38,1.19-0.55,1.79 c-0.02,0.07-0.05,0.14-0.07,0.21c-0.01,0.03-0.02,0.07-0.02,0.1c-0.19,0.71-0.37,1.41-0.52,2.12c-0.01,0.07-0.03,0.13-0.05,0.2 c-0.02,0.08-0.03,0.17-0.05,0.25c-0.06,0.28-0.11,0.56-0.16,0.85c-0.03,0.18-0.07,0.36-0.1,0.54c-0.05,0.3-0.09,0.6-0.14,0.9 c-0.02,0.13-0.04,0.26-0.06,0.38c0,0.03-0.01,0.06-0.01,0.09c-0.08,0.61-0.14,1.22-0.18,1.82c-0.01,0.12-0.02,0.25-0.02,0.37 c-0.04,0.62-0.06,1.23-0.06,1.84c0.02,6.65,2.37,11.33,6.18,13.54c0.04,0.02,0.09,0.05,0.13,0.08c0.13,0.08,0.26,0.15,0.39,0.23 c-3.8-2.21-6.16-6.89-6.17-13.54c0-0.6,0.02-1.21,0.06-1.83C128.29,135.23,128.29,135.1,128.3,134.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.4348,
    y1: 103.3699,
    x2: 158.5065,
    y2: 127.4945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEC0C2"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M162.65,128.21c-1.43-2.44-2.25-5.65-2.26-9.53c0-0.6,0.02-1.21,0.06-1.82c0.01-0.17,0.02-0.35,0.04-0.52 c0.04-0.48,0.08-0.96,0.14-1.45c0.02-0.16,0.04-0.33,0.06-0.49c0.03-0.24,0.07-0.49,0.11-0.73c0.04-0.25,0.08-0.5,0.12-0.76 c0.04-0.25,0.1-0.5,0.15-0.76c0.05-0.26,0.1-0.52,0.16-0.78c0.04-0.16,0.07-0.32,0.11-0.48c0.08-0.32,0.16-0.65,0.24-0.97 c0.04-0.15,0.08-0.3,0.12-0.45c0.05-0.19,0.11-0.38,0.16-0.58c0.14-0.5,0.3-1,0.46-1.5c0.09-0.27,0.17-0.55,0.27-0.82 c0.19-0.55,0.4-1.11,0.61-1.66c0.15-0.39,0.31-0.77,0.47-1.15c0.1-0.23,0.19-0.46,0.29-0.69c0.16-0.36,0.33-0.73,0.5-1.09 c0.11-0.23,0.21-0.47,0.33-0.71c0.22-0.46,0.45-0.9,0.69-1.35c0.08-0.14,0.15-0.29,0.22-0.44l-0.53-0.31 c-0.01,0.02-0.02,0.03-0.03,0.05c-0.07,0.14-0.14,0.27-0.21,0.41c-0.23,0.44-0.46,0.88-0.67,1.32c-0.01,0.02-0.02,0.04-0.03,0.05 c-0.11,0.22-0.2,0.45-0.31,0.67c-0.17,0.36-0.33,0.72-0.49,1.08c-0.01,0.02-0.02,0.05-0.03,0.08c-0.08,0.19-0.16,0.39-0.24,0.58 c-0.16,0.39-0.33,0.79-0.48,1.18c-0.02,0.04-0.04,0.08-0.05,0.12c-0.2,0.51-0.38,1.02-0.56,1.53c-0.06,0.16-0.11,0.32-0.16,0.49 c-0.03,0.1-0.06,0.2-0.09,0.3c-0.17,0.51-0.32,1.02-0.47,1.53c-0.03,0.11-0.07,0.22-0.1,0.33c-0.01,0.05-0.02,0.1-0.04,0.15 c-0.19,0.7-0.36,1.4-0.52,2.1c-0.01,0.05-0.03,0.11-0.04,0.16c-0.04,0.18-0.07,0.37-0.11,0.55c-0.05,0.24-0.1,0.48-0.14,0.72 c-0.05,0.27-0.09,0.53-0.13,0.79c-0.04,0.23-0.07,0.47-0.11,0.7c-0.01,0.06-0.02,0.13-0.03,0.19c-0.01,0.11-0.02,0.21-0.03,0.32 c-0.06,0.48-0.11,0.96-0.14,1.44c-0.01,0.17-0.03,0.34-0.04,0.51c-0.04,0.61-0.06,1.22-0.06,1.83c0.01,3.89,0.83,7.09,2.26,9.54 c0.84,1.44,1.89,2.61,3.13,3.49l0.53,0.31C164.54,130.82,163.49,129.64,162.65,128.21z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M132.59,91.29c0-0.67-0.48-0.94-1.07-0.6l-0.23,0.13l0,0.45c0,0.67-0.47,1.5-1.07,1.84l-8.32,4.8l0,0.15 c0,0.67,0.49,0.95,1.07,0.61l8.55-4.94c0.59-0.34,1.07-1.16,1.07-1.84L132.59,91.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.9596,
    y1: 95.0037,
    x2: 126.2332,
    y2: 93.7456
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9CFD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6AFB7"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M131.29,91.28l0-0.45l-8.32,4.8c-0.59,0.34-1.07,1.16-1.06,1.83l0,0.46l8.32-4.8 C130.82,92.78,131.29,91.95,131.29,91.28z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M132.59,96.29c0-0.67-0.48-0.94-1.07-0.6l-0.23,0.13l0,0.45c0,0.67-0.47,1.5-1.07,1.84l-8.32,4.8l0,0.15 c0,0.67,0.49,0.95,1.07,0.61l8.55-4.94c0.59-0.34,1.07-1.16,1.07-1.84L132.59,96.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.9596,
    y1: 99.9955,
    x2: 126.2332,
    y2: 98.7374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9CFD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A6AFB7"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M131.29,96.27l0-0.45l-8.32,4.8c-0.59,0.34-1.07,1.16-1.06,1.83l0,0.46l8.32-4.8 C130.82,97.77,131.29,96.95,131.29,96.27z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "165.73,145.02 138.23,160.88 138.23,163.49 165.69,147.64  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "165.69,147.64 138.23,163.49 138.23,162.33 164.72,147.1  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "164.72,147.1 138.62,162.14 138.62,161.12 164.72,146.03  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "164.72,146.03 138.62,161.12 138.62,162.14 138.23,162.33 138.23,160.88 164.72,145.6  "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_10_",
    d: "M178.33,124.18c1.13,0.8,1.82,2.31,1.82,4.4c0.01,2.09-0.67,4.39-1.79,6.49 c-1.32,2.47-3.25,4.67-5.41,5.92c-3.99,2.3-7.23,0.48-7.25-4.07c-0.01-4.55,3.21-10.1,7.2-12.4 C175.06,123.27,177,123.23,178.33,124.18z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st52"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -37.3286 221.0204)",
    className: "st1",
    cx: 164.01,
    cy: 141.36,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -35.2976 220.5727)",
    className: "st1",
    cx: 164.65,
    cy: 139.46,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -33.2667 220.1249)",
    className: "st1",
    cx: 165.3,
    cy: 137.56,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -31.2358 219.6772)",
    className: "st1",
    cx: 165.94,
    cy: 135.65,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -29.2048 219.2294)",
    className: "st1",
    cx: 166.59,
    cy: 133.75,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -27.1739 218.7817)",
    className: "st1",
    cx: 167.24,
    cy: 131.85,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -25.143 218.3339)",
    className: "st1",
    cx: 167.88,
    cy: 129.95,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -23.112 217.8862)",
    className: "st1",
    cx: 168.53,
    cy: 128.05,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -21.0811 217.4384)",
    className: "st1",
    cx: 169.17,
    cy: 126.14,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -19.0502 216.9907)",
    className: "st1",
    cx: 169.82,
    cy: 124.24,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -36.6864 222.0819)",
    className: "st1",
    cx: 165.21,
    cy: 141.36,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -34.6555 221.6342)",
    className: "st1",
    cx: 165.85,
    cy: 139.46,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -32.6245 221.1864)",
    className: "st1",
    cx: 166.5,
    cy: 137.56,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -30.5936 220.7387)",
    className: "st1",
    cx: 167.14,
    cy: 135.65,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -28.5627 220.2909)",
    className: "st1",
    cx: 167.79,
    cy: 133.75,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -26.5317 219.8432)",
    className: "st1",
    cx: 168.43,
    cy: 131.85,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -24.5008 219.3954)",
    className: "st1",
    cx: 169.08,
    cy: 129.95,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -22.4699 218.9477)",
    className: "st1",
    cx: 169.73,
    cy: 128.05,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -20.4389 218.4999)",
    className: "st1",
    cx: 170.37,
    cy: 126.14,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -18.408 218.0522)",
    className: "st1",
    cx: 171.02,
    cy: 124.24,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -36.0442 223.1434)",
    className: "st1",
    cx: 166.41,
    cy: 141.36,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -34.0133 222.6957)",
    className: "st1",
    cx: 167.05,
    cy: 139.46,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -31.9824 222.248)",
    className: "st1",
    cx: 167.7,
    cy: 137.56,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -29.9514 221.8002)",
    className: "st1",
    cx: 168.34,
    cy: 135.65,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -27.9205 221.3524)",
    className: "st1",
    cx: 168.99,
    cy: 133.75,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -25.8896 220.9047)",
    className: "st1",
    cx: 169.63,
    cy: 131.85,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -23.8586 220.457)",
    className: "st1",
    cx: 170.28,
    cy: 129.95,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -21.8277 220.0092)",
    className: "st1",
    cx: 170.92,
    cy: 128.05,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -19.7968 219.5615)",
    className: "st1",
    cx: 171.57,
    cy: 126.14,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -17.7658 219.1137)",
    className: "st1",
    cx: 172.21,
    cy: 124.24,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -35.402 224.205)",
    className: "st1",
    cx: 167.6,
    cy: 141.36,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -33.3711 223.7572)",
    className: "st1",
    cx: 168.25,
    cy: 139.46,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -31.3402 223.3095)",
    className: "st1",
    cx: 168.89,
    cy: 137.56,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -29.3092 222.8617)",
    className: "st1",
    cx: 169.54,
    cy: 135.65,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -27.2783 222.414)",
    className: "st1",
    cx: 170.19,
    cy: 133.75,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -25.2474 221.9662)",
    className: "st1",
    cx: 170.83,
    cy: 131.85,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -23.2165 221.5185)",
    className: "st1",
    cx: 171.48,
    cy: 129.95,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -21.1855 221.0707)",
    className: "st1",
    cx: 172.12,
    cy: 128.05,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -19.1546 220.623)",
    className: "st1",
    cx: 172.77,
    cy: 126.14,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -17.1237 220.1752)",
    className: "st1",
    cx: 173.41,
    cy: 124.24,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -34.7599 225.2665)",
    className: "st1",
    cx: 168.8,
    cy: 141.36,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -32.7289 224.8187)",
    className: "st1",
    cx: 169.45,
    cy: 139.46,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -30.698 224.371)",
    className: "st1",
    cx: 170.09,
    cy: 137.56,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -28.6671 223.9232)",
    className: "st1",
    cx: 170.74,
    cy: 135.65,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -26.6361 223.4755)",
    className: "st1",
    cx: 171.38,
    cy: 133.75,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -24.6052 223.0277)",
    className: "st1",
    cx: 172.03,
    cy: 131.85,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -22.5743 222.58)",
    className: "st1",
    cx: 172.67,
    cy: 129.95,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -20.5434 222.1322)",
    className: "st1",
    cx: 173.32,
    cy: 128.05,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -18.5124 221.6845)",
    className: "st1",
    cx: 173.97,
    cy: 126.14,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -16.4815 221.2367)",
    className: "st1",
    cx: 174.61,
    cy: 124.24,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -34.1177 226.328)",
    className: "st1",
    cx: 170,
    cy: 141.36,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -32.0868 225.8802)",
    className: "st1",
    cx: 170.65,
    cy: 139.46,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -30.0558 225.4325)",
    className: "st1",
    cx: 171.29,
    cy: 137.56,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -28.0249 224.9847)",
    className: "st1",
    cx: 171.94,
    cy: 135.65,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -25.994 224.537)",
    className: "st1",
    cx: 172.58,
    cy: 133.75,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -23.963 224.0892)",
    className: "st1",
    cx: 173.23,
    cy: 131.85,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -21.9321 223.6415)",
    className: "st1",
    cx: 173.87,
    cy: 129.95,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -19.9012 223.1937)",
    className: "st1",
    cx: 174.52,
    cy: 128.05,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -17.8702 222.746)",
    className: "st1",
    cx: 175.16,
    cy: 126.14,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -15.8393 222.2982)",
    className: "st1",
    cx: 175.81,
    cy: 124.24,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -33.4755 227.3895)",
    className: "st1",
    cx: 171.2,
    cy: 141.36,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -31.4446 226.9417)",
    className: "st1",
    cx: 171.84,
    cy: 139.46,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -29.4137 226.494)",
    className: "st1",
    cx: 172.49,
    cy: 137.56,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -27.3827 226.0462)",
    className: "st1",
    cx: 173.14,
    cy: 135.65,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -25.3518 225.5985)",
    className: "st1",
    cx: 173.78,
    cy: 133.75,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -23.3209 225.1507)",
    className: "st1",
    cx: 174.43,
    cy: 131.85,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -21.2899 224.703)",
    className: "st1",
    cx: 175.07,
    cy: 129.95,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -19.259 224.2552)",
    className: "st1",
    cx: 175.72,
    cy: 128.05,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -17.2281 223.8075)",
    className: "st1",
    cx: 176.36,
    cy: 126.14,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -15.1971 223.3597)",
    className: "st1",
    cx: 177.01,
    cy: 124.24,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -32.8334 228.451)",
    className: "st1",
    cx: 172.4,
    cy: 141.36,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -30.8024 228.0033)",
    className: "st1",
    cx: 173.04,
    cy: 139.46,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -28.7715 227.5555)",
    className: "st1",
    cx: 173.69,
    cy: 137.56,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -26.7406 227.1078)",
    className: "st1",
    cx: 174.33,
    cy: 135.65,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -24.7096 226.66)",
    className: "st1",
    cx: 174.98,
    cy: 133.75,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -22.6787 226.2122)",
    className: "st1",
    cx: 175.62,
    cy: 131.85,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -20.6478 225.7645)",
    className: "st1",
    cx: 176.27,
    cy: 129.95,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -18.6168 225.3168)",
    className: "st1",
    cx: 176.92,
    cy: 128.05,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -16.5859 224.869)",
    className: "st1",
    cx: 177.56,
    cy: 126.14,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -14.555 224.4212)",
    className: "st1",
    cx: 178.21,
    cy: 124.24,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -32.1912 229.5125)",
    className: "st1",
    cx: 173.6,
    cy: 141.36,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -30.1602 229.0648)",
    className: "st1",
    cx: 174.24,
    cy: 139.46,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -28.1293 228.617)",
    className: "st1",
    cx: 174.89,
    cy: 137.56,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -26.0984 228.1693)",
    className: "st1",
    cx: 175.53,
    cy: 135.65,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -24.0675 227.7215)",
    className: "st1",
    cx: 176.18,
    cy: 133.75,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -22.0365 227.2738)",
    className: "st1",
    cx: 176.82,
    cy: 131.85,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -20.0056 226.826)",
    className: "st1",
    cx: 177.47,
    cy: 129.95,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -17.9747 226.3783)",
    className: "st1",
    cx: 178.11,
    cy: 128.05,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -15.9437 225.9305)",
    className: "st1",
    cx: 178.76,
    cy: 126.14,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -13.9128 225.4828)",
    className: "st1",
    cx: 179.4,
    cy: 124.24,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -31.549 230.574)",
    className: "st1",
    cx: 174.79,
    cy: 141.36,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -29.5181 230.1263)",
    className: "st1",
    cx: 175.44,
    cy: 139.46,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -27.4871 229.6785)",
    className: "st1",
    cx: 176.09,
    cy: 137.56,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -25.4562 229.2308)",
    className: "st1",
    cx: 176.73,
    cy: 135.65,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -23.4253 228.783)",
    className: "st1",
    cx: 177.38,
    cy: 133.75,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -21.3943 228.3353)",
    className: "st1",
    cx: 178.02,
    cy: 131.85,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -19.3634 227.8875)",
    className: "st1",
    cx: 178.67,
    cy: 129.95,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -17.3325 227.4398)",
    className: "st1",
    cx: 179.31,
    cy: 128.05,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -15.3016 226.992)",
    className: "st1",
    cx: 179.96,
    cy: 126.14,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -13.2706 226.5443)",
    className: "st1",
    cx: 180.6,
    cy: 124.24,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -30.9068 231.6355)",
    className: "st1",
    cx: 175.99,
    cy: 141.36,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -28.8759 231.1878)",
    className: "st1",
    cx: 176.64,
    cy: 139.46,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -26.845 230.74)",
    className: "st1",
    cx: 177.28,
    cy: 137.56,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -24.814 230.2923)",
    className: "st1",
    cx: 177.93,
    cy: 135.65,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -22.7831 229.8445)",
    className: "st1",
    cx: 178.57,
    cy: 133.75,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -20.7522 229.3968)",
    className: "st1",
    cx: 179.22,
    cy: 131.85,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -18.7212 228.949)",
    className: "st1",
    cx: 179.87,
    cy: 129.95,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -16.6903 228.5013)",
    className: "st1",
    cx: 180.51,
    cy: 128.05,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -14.6594 228.0535)",
    className: "st1",
    cx: 181.16,
    cy: 126.14,
    rx: 0.56,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4642 -0.8858 0.8858 0.4642 -12.6284 227.6058)",
    className: "st1",
    cx: 181.8,
    cy: 124.24,
    rx: 0.56,
    ry: 0.31
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheLinge);
export default __webpack_public_path__ + "static/media/Sèche-linge.7cd23404796b6628bcda771d61a8b6f4.svg";
export { ForwardRef as ReactComponent };